namespace app.documentos {

    export class DownloadLinkDirective implements ng.IDirective {

        public restrict: string = "A";

        public static factory() {
            return ["$parse", "$cookies", ($parse: ng.IParseService, $cookies: ng.cookies.ICookiesService) => {
                return new DownloadLinkDirective($parse, $cookies);
            }];
        }

        public constructor(private $parse: ng.IParseService, private $cookies: ng.cookies.ICookiesService) {
            this.clickCallback = this.clickCallback.bind(this);
            this.link = this.link.bind(this);
        }

        public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
            element.bind("click", () => this.clickCallback(scope, attrs));  
        }

        private clickCallback(scope: ng.IScope, attrs: ng.IAttributes) {
            const conteudo = attrs["downloadLink"];
            let url = this.$parse(conteudo)(scope);
            const urlParams = new URLSearchParams(url);
            let anchor = document.createElement("a");

            if (!!attrs["filename"]) {
                let nomeArquivo = attrs["filename"];
                anchor.download = this.$parse(nomeArquivo)(scope);
            }

            if (!urlParams.has("access_token")) {
                url += url.indexOf("?") === -1 ? "?" : "&";
                url += "access_token=" + this.$cookies.get("access_token");
            }
            anchor.href = url;
            anchor.hidden = true;
            anchor.target = "_blank";            
            anchor.click();
            anchor = null;
        }

    }
    angular.module("app.documentos").directive("downloadLink", DownloadLinkDirective.factory());

}